import React from 'react';
import { CONS, MANNER_ORDER, GRID_PLACES, placeOf, mannerOf } from './data';
import { toneOf } from './ui';
import { useT, useL } from '../../lib/lessonI18n';

const TXT = { lime: 'text-lime-300', orange: 'text-orange-300', cyan: 'text-cyan-200' };

// IPA-style chart: places across, manners down; voiceless left, voiced right in each cell.
export const ConsonantGrid = ({ onPick, hlPlace, hlManner }) => {
  const T = useT();
  const L = useL();
  
  return (
    <div className="overflow-x-auto" data-testid="consonant-grid">
      <table className="w-full min-w-[720px] border-collapse text-center">
        <thead>
          <tr>
            <th className="p-2" />
            {GRID_PLACES.map((p) => (
              <th key={p} className={`p-2 text-[10px] font-bold uppercase tracking-wider ${hlPlace === p ? 'text-orange-300' : 'text-slate-400'}`}>{L(placeOf(p).label)}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {MANNER_ORDER.map((m) => (
            <tr key={m} className="border-t border-slate-800/80">
              <th className={`p-2 text-left text-[10px] font-bold uppercase tracking-wider ${hlManner === m ? 'text-orange-300' : 'text-slate-400'}`}>{L(mannerOf(m).label)}</th>
              {GRID_PLACES.map((p) => {
                const cell = CONS.filter((c) => c.manner === m && (c.place === p || (p === 'velar' && c.place === 'labiovelar')));
                const lit = (hlPlace && hlPlace === p) || (hlManner && hlManner === m);
                return (
                  <td key={p} className={`p-1.5 transition-colors ${lit ? 'bg-orange-500/10' : ''}`}>
                    <div className="flex justify-center gap-1">
                      {cell.sort((a, b) => Number(a.voice) - Number(b.voice)).map((c) => (
                        <button key={c.id} onClick={() => onPick?.(c.id)} title={`${c.ipa} · ${c.key}`} data-testid={`grid-cons-${c.id}`}
                          className={`h-9 min-w-[2.25rem] rounded-lg border border-white/5 bg-slate-950/50 px-1.5 font-mono text-lg font-black transition-all hover:-translate-y-0.5 hover:border-orange-400/60 ${TXT[toneOf(c)]}`}>{c.ipa}</button>
                      ))}
                    </div>
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
      <p className="mt-3 text-center text-[11px] text-slate-500"><span className="text-cyan-300">●</span> {T('sorda', 'voiceless')} · <span className="text-orange-300">●</span> {T('sonora (ostruente)', 'voiced (obstruent)')} · <span className="text-lime-300">●</span> {T('sonorante', 'sonorant')} · {T('in ogni casella: sorda a sinistra, sonora a destra', 'in each cell: voiceless left, voiced right')} · {T('/w/ è labiovelare', '/w/ is labio-velar')}</p>
    </div>
  );
};
